<template>
  <header class="header">
    <!-- <b-navbar style="background-color: white" toggleable="lg" type="light">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand @click="navigateHome" style="cursor:pointer;">
        <img src="../assets/logos/main-logo-color.png" width="100px">
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav class="ml-5 mt-auto mb-auto">
          <label class="moow-subheader">{{title}}</label>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto" >
          <b-navbar-nav>
            <b-button  v-if="btn" :disabled="disable" style="background-color:transparent;color:#1f8efa;border:none;font-weight:bold" @click="saveAndExit">Save and Exit</b-button>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar> -->

    <b-progress :value="progress" :max="100" height="6px" class="mb-12"></b-progress>
    <!-- <p class="moow-link-button-simple" style="text-align: right" v-if="btn" @click="saveAndExit"><u>Save & Exit</u></p> -->
  </header>
</template>

<script>
  import axios from 'axios'
  import {
    onBeforeAddListingSaveAndExit
  } from '../functions.js'
  export default {
    props: ['progress', 'title','btn', 'disable'],
    props:{
      progress:Number,
      title:String,
      btn:{
        type:Boolean,
        default:true
      },
      disable:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return {
        // btn:false
      }
    },
    methods: {
      navigateHome(){
        this.$router.push({
          name: 'dashboard'
        })
      },
      saveAndExit() {
        onBeforeAddListingSaveAndExit()
        // this.$parent.saveAndExit()
      }
    },
    created() {
      //this.save = this.$parent.save
    }
  }

</script>
<style>
    @import '../assets/styles/global.css';

  .header {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/HeaderBasic.vue